/* Cart Add On Customization */
(function ($) {
  function addVariantToCart(p_options) {
    var data = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
    };

    return new Promise(function (resolve, reject) {
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        async: true,
        data: data,
        dataType: "json",
        error: function (error) {
          reject(error);
        },
        success: function (data) {
          resolve(data);
        },
        cache: false,
      });
    });
  }

  function getCartData() {
    return new Promise(function (resolve, reject) {
      $.getJSON("/cart.js", function (data) {
        resolve(data);
      });
    });
  }

  var isPage = location.pathname.indexOf("/pages/") !== -1;
  var isProductPage = location.pathname.indexOf("/products/") !== -1;

  $(function () {
    if (isProductPage) {
      // lazy load videos
      $(".video-wrapper .button").click(function () {
        lazyframe($(this).parents(".video-wrapper").find(".lazyvideo"));
      });
    }

    // Add On Items
    $(document).on("click", ".addon-btn", function (e) {
      e.preventDefault();
      var variant_id = $(e.currentTarget).data("variant-id");

      addVariantToCart({
        variant_id: variant_id,
        quantity: 1,
      }).then(function () {
        window.PXUTheme.jsAjaxCart.updateView();
      });
    });
  });
})(jQuery);

jQuery(document).ready(function ($) {
  // Pickup Badges for Product and Collection Pages
  var $svg_lr = $(
    '<div class="ow-pickup-badge">' + $("#ow-svg-lr-baggs").html() + "</div>"
  );
  var $svg_fishman = $(
    '<div class="ow-pickup-badge">' + $("#ow-svg-fishman").html() + "</div>"
  );
  var $svg_high = $(
    '<div class="ow-pickup-badge">' + $("#ow-svg-high-output").html() + "</div>"
  );
  var $svg_seymour = $(
    '<div class="ow-pickup-badge">' + $("#ow-svg-seymour-duncan").html() + "</div>"
  );
  // check for mobile
  var isMobile = window.matchMedia("(max-width: 798px)").matches;

  // Check for left handed guitars
  function isLefty(handle = "") {
    if (handle.includes("left") || handle.includes("left-handed")) {
      return true;
    } else {
      return false;
    }
  }

  // Mobile Vertical Guitar Image
  var mobileVerticalImages = function () {
    if (window.Orangewood.template_name == "product") {
      if (
        window.Orangewood.product_type == "Guitars" ||
        window.Orangewood.product_type == "Ukuleles"
      ) {
        var $el = $(".product-gallery__main");

        $("body").addClass("ow-vertical-image");

        if (isLefty(window.location.pathname)) {
          $("body").addClass("ow-lefty");
        }

        // SV - Mobile vertical images
        function setupMobileGallery() {
          $el[isMobile ? "addClass" : "removeClass"]("mobile-gallery");

          $el.find(".product-gallery__image").each(function () {
            var $imageContainer = $(this);
            if (isMobile) {
              $imageContainer.css({
                height: $imageContainer.find("img").width() * 1.4,
              });
            } else {
              $imageContainer.css({
                height: "auto",
              });
            }
          });

          var flickity = Flickity.data(".product-gallery__main");
          if (flickity !== undefined) {
            flickity.resize();
          }
        }

        setupMobileGallery();
      }
    }
  };

  // Pickup SVG Logo Support - Collection Page
  var collectionPickups = function () {
    if (window.Orangewood.template_name != "collection") {
      return false;
    }

    var handle = "";
    var $el;

    for (var i = 0; i < window.Orangewood.pickup_lr.length; i++) {
      handle = window.Orangewood.pickup_lr[i];
      $el = $(
        '.product-image__wrapper a[href$="' + handle + '"] .image-element__wrap'
      );

      if (isLefty(handle)) {
        $el.parent().addClass("ow-lefty");
      }

      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_lr[0].outerHTML);
      }
    }

    for (var i = 0; i < window.Orangewood.pickup_fishman.length; i++) {
      handle = window.Orangewood.pickup_fishman[i];
      $el = $(
        '.product-image__wrapper a[href$="' + handle + '"] .image-element__wrap'
      );

      if (isLefty(handle)) {
        $el.parent().addClass("ow-lefty");
      }
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_fishman[0].outerHTML);
      }
    }

    for (var i = 0; i < window.Orangewood.pickup_high.length; i++) {
      handle = window.Orangewood.pickup_high[i];
      $el = $(
        '.product-image__wrapper a[href$="' + handle + '"] .image-element__wrap'
      );

      if (isLefty(handle)) {
        $el.parent().addClass("ow-lefty");
      }
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_high[0].outerHTML);
      }
    }

    for (var i = 0; i < window.Orangewood.pickup_seymour.length; i++) {
      handle = window.Orangewood.pickup_seymour[i];
      $el = $(
        '.product-image__wrapper a[href$="' + handle + '"] .image-element__wrap'
      );

      if (isLefty(handle)) {
        $el.parent().addClass("ow-lefty");
      }
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_seymour[0].outerHTML);
      }
    }
  };

  // Pickup SVG Logo Support - Product Page
  var productPickup = function () {
    if (window.Orangewood.template_name != "product") {
      return false;
    }

    var $el = $(".product-gallery__image:first-child");

    if (
      window.Orangewood.product_pickup == "LR Baggs" ||
      window.Orangewood.product_pickup == "LR Baggs Element Bronze VTC"
       ) {
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_lr[0].outerHTML);
      }
    } else if (
      window.Orangewood.product_pickup == "Fishman" ||
      window.Orangewood.product_pickup == "Fishman Sonitone EQ"
    ) {
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_fishman[0].outerHTML);
      }
    } else if (window.Orangewood.product_pickup == "High Output") {
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_high[0].outerHTML);
      }
    } else if (window.Orangewood.product_pickup == "Seymour Duncan") {
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_seymour[0].outerHTML);
      }
    } else if (window.Orangewood.product_pickup == "LR Baggs Element Bronze") {
      if ($el.find(".ow-pickup-badge").length == 0) {
        $el.append($svg_lr[0].outerHTML);
      }    
    }
  };

  // Best Seller Sticker for mobile
  var productSticker = function () {
    if ($(".product-page").length && $(".sticker-holder").length) {
      if (isMobile) {
        var $stickers = $(".sticker-holder").clone();
        $stickers.addClass("ow-mobile-sticker");
        $stickers.css("font-size", "18px");
        $(".sticker-holder:not(.ow-mobile-sticker)").hide();
        $stickers.prependTo(".product__images");
      } else {
        $(".sticker-holder").show();
        $(".ow-mobile-sticker").hide();
      }
    }
  };

  // Spec comparison page
  var specPageInit = function () {
    $(".ow-spec-toggle").select2();

    // initial values
    $(".ow-spec-1 .ow-spec-toggle").prop("selectedIndex", 0);
    $(".ow-spec-2 .ow-spec-toggle").prop("selectedIndex", 1);

    specPageChange(1, $(".ow-spec-1 .ow-spec-toggle").val());
    specPageChange(2, $(".ow-spec-2 .ow-spec-toggle").val());

    $(".ow-spec-1 .ow-spec-toggle").on("change", function () {
      specPageChange(1, $(this).val());
    });
    $(".ow-spec-2 .ow-spec-toggle").on("change", function () {
      specPageChange(2, $(this).val());
    });

    $(".ow-spec-2 .ow-spec-toggle").trigger("change");

    // init plugins
    $(".ow-spec-toggle").on("select2:open", function () {
      //$(".select2-search input").prop("focus", false);
    });

    var sticky = new Sticky(".ow-spec-toggle-wrap", {
      marginTop:
        //$("#shopify-section-announcement-bar").height() +
        $(".header-section").height(),
      stickyWrap: true,
      stickyClass: "is-sticky",
    });

    $(window).on("load resize", function () {
      sticky.marginTop =
        //$("#shopify-section-announcement-bar").height() +
        $(".header-section").height();
      sticky.update();
    });

    $(window).on("load", function () {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const model = urlParams.get("model");
      if (model) {
        $(".ow-spec-1 .ow-spec-toggle").val(model).trigger("change");
      }
    });
  };

  var specPageChange = function (col, id) {
    var $template = $($("template#" + id).prop("content"));

    var product = $template.find(".ow-spec-product").html();
    var overview = $template.find('[data-id="overview"]').clone().html();
    var body = $template.find('[data-id="body"]').clone().html();
    var neck = $template.find('[data-id="neck"]').clone().html();
    var details = $template.find('[data-id="details"]').clone().html();
    var accessories = $template.find('[data-id="accessories"]').clone().html();

    $(".ow-spec-" + col + " .ow-spec-product").html(product);
    $(".ow-spec-overview .ow-spec-" + col).html(overview);
    $(".ow-spec-body .ow-spec-" + col).html(body);
    $(".ow-spec-neck .ow-spec-" + col).html(neck);
    $(".ow-spec-details .ow-spec-" + col).html(details);
    $(".ow-spec-accessories .ow-spec-" + col).html(accessories);

    $(".ow-spec-product img").on("load", function () {
      if (isMobile) {
        $(".ow-spec-product-img").css({
          height: $(".ow-spec-product img").width() * 1.4,
        });
      } else {
        $(".ow-spec-product-img").css({
          height: "auto",
        });
      }
    });
  };

  // mobile menu
  var mobileMenu = function () {
    $(".mobile-menu__toggle-button").on("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      $(".ow-mobile-menu").addClass("active");
      return false;
    });

    $(".ow-mobile-menu .icon-close").on("click", function () {
      $(".ow-mobile-menu").removeClass("active");
    });

    // navigation
    $(".ow-mobile-menu-links a").click(function (e) {
      if ($(this).attr("href") == "#") {
        e.preventDefault();
        $(".ow-mobile-menu-links").removeClass("active");
        $(
          '.ow-mobile-menu-links[data-key="' + $(this).attr("data-to") + '"]'
        ).addClass("active");
        $(".ow-mobile-menu").removeClass("top-level-active");
        $(".ow-mobile-menu").addClass("sub-level-active");
        $(".ow-menu-heading").text($(this).text());
        return false;
      }
    });

    // back button
    $(".ow-mobile-menu .icon-left-arrow").click(function () {
      $(".ow-menu-heading").text(
        $(
          'a[data-to="' +
            $(".ow-mobile-menu-links.active").attr("data-back") +
            '"]'
        ).text()
      );
      var $prev_menu = $(
        '.ow-mobile-menu-links[data-key="' +
          $(".ow-mobile-menu-links.active").attr("data-back") +
          '"]'
      );
      $(".ow-mobile-menu-links").removeClass("active");

      if ($prev_menu.hasClass("ow-mobile-menu-sub-level")) {
        $(".ow-mobile-menu").removeClass("top-level-active");
        $(".ow-mobile-menu").addClass("sub-level-active");
      } else {
        $(".ow-mobile-menu").removeClass("sub-level-active");
        $(".ow-mobile-menu").addClass("top-level-active");
      }

      $prev_menu.addClass("active");
    });
  };

  // quizkit customizations
  var quizKit = function () {
    var full_audio = document.getElementById("quiz-audio-full");
    var bright_audio = document.getElementById("quiz-audio-bright");
    var current_step = 0;
    var total_steps = 7;

    var $progress = $('<div id="quiz-kit-progress"></div>');

    setInterval(function () {
      $("#quiz-kit-content").prepend($progress);
      var step_text = $('[id*="quiz-kit-question-navigation-"]').text();
      var width = 0;
      step_text = step_text.split(" ");

      current_step = step_text[0];
      total_steps = step_text[2];
      width = (current_step / total_steps) * 100.0;

      $progress.css("width", width + "%");

      $('[id*="quiz-kit-subscribe-"] > h2[id*="subheading"]')
        .detach()
        .insertAfter('[id*="quiz-kit-subscribe-"] > h1[id*="heading"]');
    }, 500);

    $("body").on(
      "click",
      '[id*="quiz-kit-question-image-text-item-"]:contains("BRIGHT")',
      function () {
        bright_audio.play();
        full_audio.pause();
        full_audio.currentTime = 0;
      }
    );
    $("body").on(
      "click",
      '[id*="quiz-kit-question-image-text-item-"]:contains("FULL")',
      function () {
        full_audio.play();
        bright_audio.pause();
        bright_audio.currentTime = 0;
      }
    );
  };

  // press section
  var pressSection = function () {
    if ($(".ow-press").length > 0) {
      $(window).on("load", function () {
        var $next_logo = "";
        var slider_delay = 5000;
        var animation = 300;
        /*var timer = setInterval(function () {
          change_press_logo();
        }, slider_delay);*/

        // auto-rotate quotes
        function change_press_logo(manual = false, reverse = false, $el) {
          if (manual) {
            $next_logo = $el;
            //clearInterval(timer);
            /*timer = setInterval(function () {
              change_press_logo();
            }, slider_delay);*/
          } else {
            if (reverse) {
              if ($(".ow-press__logo:first-child").hasClass("active")) {
                $next_logo = $(".ow-press__logo:last-child");
              } else {
                $next_logo = $(".ow-press__logo.active").prev();
              }
            } else {
              if ($(".ow-press__logo:last-child").hasClass("active")) {
                $next_logo = $(".ow-press__logo:first-child");
              } else {
                $next_logo = $(".ow-press__logo.active").next();
              }
            }
          }

          $(".ow-press__logo.active").removeClass("active");
          $(".ow-press__dot.active").removeClass("active");
          $next_logo.addClass("active");
          $(
            `.ow-press__dot[data-index="${$next_logo.attr("data-index")}"]`
          ).addClass("active");
          $(".ow-press__quote").fadeOut(animation, function () {
            $(".ow-press__quote")
              .html(`"${$next_logo.attr("data-quote")}"`)
              .fadeIn(animation);
          });
        }

        $(".ow-press__logo").on("click", function (e) {
          e.preventDefault();
          change_press_logo(true, false, $(this));
          return false;
        });

        $(".ow-press__dot").on("click", function (e) {
          e.preventDefault();
          change_press_logo(
            true,
            false,
            $(`.ow-press__logo[data-index="${$(this).attr("data-index")}"]`)
          );
          return false;
        });

        let touchstartX = 0;
        let touchendX = 0;

        const slider = document.querySelector(".ow-press__carousel");

        function handleGesture() {
          if (touchendX < touchstartX) {
            change_press_logo();
          }
          if (touchendX > touchstartX) {
            change_press_logo(false, true);
          }
        }

        slider.addEventListener("touchstart", (e) => {
          touchstartX = e.changedTouches[0].screenX;
        });

        slider.addEventListener("touchend", (e) => {
          touchendX = e.changedTouches[0].screenX;
          handleGesture();
        });
      });
    }
  };

  pressSection();

  // sticky blog header
  /*var stickyBlog = function () {
    const el = document.querySelector("#shopify-section-header-classic");
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(el);
  };

  if ($("body").hasClass("blog") || $("body").hasClass("article")) {
    stickyBlog();
  }*/

  // collection list slideshow
  $(".ow-slideshow").flickity({
    wrapAround: true,
    pageDots: false,
    setGallerySize: window.matchMedia("screen and (max-width: 768px)").matches,
  });

  $("[data-announcement-carousel]").flickity({
    autoPlay: Number($("[data-announcement-carousel]").attr("data-delay")),
    pageDots: false,
    prevNextButtons: false,
    cellAlign: "center",
  });

  // Initialize
  $(window).on("resize", function (e) {
    isMobile = window.matchMedia("(max-width: 798px)").matches;

    //mobileVerticalImages();
    collectionPickups();
    productPickup();
    //productSticker();
  });

  $(window).on("shopify:section:load", function () {
    isMobile = window.matchMedia("(max-width: 798px)").matches;

    //mobileVerticalImages();
    collectionPickups();
    productPickup();
    //productSticker();
  });

  //mobileVerticalImages();
  collectionPickups();
  productPickup();
  //productSticker();
  mobileMenu();

  $(window).on("collection::filtered", () => {
    collectionPickups();
  });

  if ($("body").hasClass("page-spec-comparison")) {
    specPageInit();
  }

  $(window).on("load", function () {
    if ($("body").hasClass("page-quiz-kit-lc-tfyaqjy")) {
      quizKit();
    }

    var $mobile_header = $(
      '.mobile-header[data-enable-overlay="true"]'
    ).parent();
    $mobile_header.css("margin-bottom", -1 * $mobile_header.height());
  });

  /*const lightbox = GLightbox({
    selector: '.product-gallery__link',
    openEffect: 'fade',
    closeEffect: 'fade',
  });*/

  if (document.querySelector("[data-product-gallery-main]")) {
    const pdpGallery = lightGallery(
      document.querySelector("[data-product-gallery-main]"),
      {
        plugins: [lgZoom, lgRotate],
        selector: ".product-gallery__link",
        download: false,
        getCaptionFromTitleOrAlt: false,
        startClass: "lg-start-fade",
        flipVertical: false,
        flipHorizontal: false,
        mobileSettings: {
          showCloseIcon: true
        }
      }
    );
  }

  // product videos
  function productVideoPlays() {
    $('.product-videos [data-play]').on('click', (e) => {
      e.preventDefault()
      const video = e.target.closest('[data-video]')
      const videoID = e.currentTarget.dataset.play.split('&')[0]

      video.innerHTML = `
        <iframe
          width="1920"
          height="1080"
          src="https://www.youtube.com/embed/${videoID}?autoplay=1&loop=1"
          title="YouTube video player"
          frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
      `
    })
  }

  productVideoPlays();

  // combined pdp listings
  $("body").on(
    "click",
    '[data-product-thumbnail-swatch]',
    function () {
      const imageUrl = $(this).data('product-image')
      const hoverUrl = $(this).data('product-image-hover')
      const productUrl = $(this).data('product-url')
      const productHandle = $(this).data('product-handle');
      const onSale = $(this).data('product-on-sale');

      const $productCard = $(this).parents('.product__grid-item')
      $productCard.find('.image__container').addClass('loading')

      $productCard.find('[data-product-thumbnail-swatch]').removeClass('active')
      $productCard.find('a').attr('href', productUrl)

      if (onSale) {
        $productCard.find('.thumbnail-sticker--sale').show();
      } else {
        $productCard.find('.thumbnail-sticker--sale').hide();
      }

      fetch(window.Shopify.routes.root + `products/${productHandle}?view=_thumbnail-sticker`)
        .then((response) => response.text())
        .then((html) => {
          $productCard.find('.sticker-holder').replaceWith(html);
        })
        .catch((error) => console.error(error))

      fetch(window.Shopify.routes.root + `products/${productHandle}?view=_thumbnail-info`)
        .then((response) => response.text())
        .then((html) => {
          $productCard.find('[data-product-thumbnail-price]').html(html);
        })
        .catch((error) => console.error(error))

      const imagePromise = [imageUrl, hoverUrl].map((url) => {
        new Promise((res) => {
          const img = new Image(url)
          img.onload = () => res()
        })
      })

      Promise.all(imagePromise).then(data => {
        $(this).addClass('active')

        setTimeout(() => {
          $productCard.find('.product-thumbnail__main-image').attr('srcset', '').attr('src', imageUrl)
          $productCard.find('.product-thumbnail__hover-image').attr('srcset', '').attr('src', hoverUrl)
          $productCard.find('.image__container').removeClass('loading')
        }, 250)
      })
    }
  );

  $(window).on("popstate", function(e) {
    if (e.originalEvent.state !== null) {
      location.reload()
    }
  });

  function switchCombinedListing($container) {
    const templateProduct = document.querySelector('#template-product')
    templateProduct.classList.add('loading')

    const swatch = $container.find('.active[data-product-combined-swatch]').attr('data-product-combined-swatch')
    const option = $container.find('.active[data-product-combined-option]').attr('data-product-combined-option')

    let product = window.ProductCombinedListings.filter((p) => p.combined == (swatch + '-' + option))

    if (product.length === 0) {
      product = window.ProductCombinedListings.filter((p) => p.product.id !== window.CurrentProductID)
      product = product[0]
      window.CurrentProductID = product.product.id
    } else {
      product = product[0]
    }

    const productUrl = '/products/' + product.product.handle
    //window.location.href = '/products/' + product[0].product.handle

    fetch(productUrl)
      .then((response) => response.text())
      .then((html) => {

        if (html.includes('klaviyo-bis-trigger')) {
          window.history.replaceState({}, "", productUrl)
          window.location.reload();
        } else {
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, "text/html")

          const productTemplate = doc.querySelector('#template-product')
          templateProduct.innerHTML = productTemplate.innerHTML

          // re-init everything
          setTimeout(() => {
            window.PXUTheme.jsProduct.init($('.product-main'))
            window.PXUTheme.jsRecommendedProducts.init($('.jsRecommendedProducts'))
            productVideoPlays()
            window.Orangewood.product_type = product.product_type;
            window.Orangewood.product_pickup = product.product_pickup;
            productPickup()

            if (window.affirm) {
              window.affirm.ui.refresh()
            }
          }, 100)

          setTimeout(() => {
            window.history.replaceState({}, "", productUrl)
            updateSoldOutSwatches()
            //mobileVerticalImages()
          }, 50)

          setTimeout(() => {
            jdgmCacheServer.reloadAll()
            templateProduct.classList.remove('loading')
            productExtraEvents();
          }, 200)
        }
      })
  }

  $('body').on('click', '[data-product-combined-swatch]', function() {
    $('[data-product-combined-swatch]').removeClass('active')
    $(this).addClass('active')
    switchCombinedListing($(this).parents('[data-product-combined]'))
  })

  $('body').on('click', '[data-product-combined-option]', function() {
    $('[data-product-combined-option]').removeClass('active')
    $(this).addClass('active')
    switchCombinedListing($(this).parents('[data-product-combined]'))
  })

  // handle sold out swatches
  function updateSoldOutSwatches() {
    const combined = $('[data-product-combined]')
    if (combined.length > 0) {
      const soldOutGroupedProducts = window.ProductCombinedListings.filter((product) => {
        return !product.product.available
      })

      const activeSwatch = document.querySelector('.active[data-product-combined-swatch]')
      const combinedOptions = document.querySelectorAll('[data-product-combined-option]')

      if (activeSwatch) {
        combinedOptions.forEach((el) => {
          const combinationHandle = activeSwatch.dataset.productCombinedSwatch + '-' + el.dataset.productCombinedOption
          const isSoldOut = soldOutGroupedProducts.filter((p) => p.combined === combinationHandle)
          if (isSoldOut.length > 0) {
            el.classList.add('oos')
          }
        })
      }
    }
  }

  updateSoldOutSwatches()

  let jdgmIntervalCount = 0;
  const jdgmInterval = setInterval(() => {
    if (jdgmCacheServer) {
      jdgmCacheServer.reloadAll();
      clearInterval(jdgmInterval);
    }

    if (jdgmIntervalCount > 50) {
      clearInterval(jdgmInterval);
    }

    jdgmIntervalCount++;
  }, 100);

  function productExtraEvents() {
    // top wood guide modal
    $('[data-top-wood-guide-close]').on('click', (e) => {
      e.preventDefault();
      $('[data-top-wood-guide-modal]').removeClass('active');
    })

    $(document).on('click', (e) => {
      const $target = $(e.target);
      if (!$target.closest('.wood-guide__wrap').length && $('[data-top-wood-guide-modal]').hasClass('active')) {
        $('[data-top-wood-guide-modal]').removeClass('active');
      }
    })

    $('[data-top-wood-guide-open]').on('click', (e) => {
      e.preventDefault();
      setTimeout(() => {
        $('[data-top-wood-guide-modal]').addClass('active');
      }, 100)
    })

    $('[data-product-description-more-toggle]').on('click', (e) => {
      e.preventDefault();
      $('[data-product-description-more-toggle]').toggleClass('active');
      $('[data-product-description-more]').slideToggle('slow')
    })

    $('[data-pdp-specs-toggle]').on('click', (e) => {
      e.preventDefault()

      $('[data-pdp-specs-toggle]').not(e.target).removeClass('active')
      $(e.target).addClass('active')

      $('[data-pdp-specs-content]').not(e.target).addClass('hidden')
      $(`[data-pdp-specs-content="${e.target.dataset.pdpSpecsToggle}"]`).removeClass('hidden')
    })
  }

  productExtraEvents();
});

//External links to open in new tab

(function () {
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
      links[i].rel = "noreferrer noopener";
    }
  }
})();

window.addEventListener('load', () => {
  jdgmCacheServer.reloadAll();
});
